import { GetProcessesByAgentRequest, PaginatedResponse } from "@/services/processes-by-agent/getProcessesByAgentService";

export function useProcessesByAgent() {
  const getProcessesByAgent = async (req: GetProcessesByAgentRequest, signal: AbortSignal) => {
    const params = new URLSearchParams({
      id: req.id,
      ...(req.page !== undefined && { page: req.page.toString() }),
      ...(req.size !== undefined && { size: req.size.toString() })
    });

    const result = !req.agentes ? await fetch(`/api/processes-by-agent?${params.toString()}`, {
      method: "GET",
      signal
    }) : await fetch(`/api/processes-by-agent?${params.toString()}`, {
      method: "POST",
      body: JSON.stringify({ ...req, agentes: req.agentes }),
      signal
    });
    const { data } = await result.json();
    const resultJson = data as PaginatedResponse;
    return resultJson;
  };
  return getProcessesByAgent;
}
